export default "__VITE_ASSET___$nsrZr___"